import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=9cd642f6&scoped=true"
import script from "./GoodsDetail.vue?vue&type=script&lang=js"
export * from "./GoodsDetail.vue?vue&type=script&lang=js"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=9cd642f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd642f6",
  null
  
)

export default component.exports